<template>
    <CModal title="Codigo de Acceso" :color="colorModal" :show.sync="dailyCodeModal">
      <CInput
        label="Código:"
        v-model="code"
        type="text"
      />
      <template #footer>
        <CButton @click="sendDailyCode" color="success">Confirmar</CButton>
      </template>
    </CModal>
</template>

<script>

import store from '../../../store'
import ws from '../../../services/login';

export default {
  name: 'DailyCodeModal',
  props: {

  },
  data () {
    return {
      dailyCodeModal: false,
      colorModal: 'info',
      code: "",
    }
  },
  methods: {
    async show () {
      this.dailyCodeModal = true;     
    },
    sendDailyCode(){
      this.$emit("validateCode",this.code);            
    },
    showToast(type, message){
      store.commit('toast', {color: type, message: message});
    },
    hide () {
      this.dailyCodeModal = false;
    },
    loading(){
      store.commit('loading');
    },
    loaded(){
      store.commit('loaded');
    }
  }
}
</script>